import { getElementById } from "../util/Utils";

export type DummyExperimentVariation = "StatusQuo" | "DummyVar1" | "DummyVar2";
export type NextBestFacetExperimentVariation = "StatusQuo" | "ValueFacet" | "FacetValue" | "FacetOnly";
export type FilterbarExperimentVariation = "StatusQuo" | "GroupB" | "GroupC";
export type OttoUpLogoExperimentVariation = "StatusQuo" | "Logo";
export type PolarisSwitchButtonExperimentVariation = "E3972A" | "E3972B";

export type Experiments = {
  [key: string]:
    | DummyExperimentVariation
    | NextBestFacetExperimentVariation
    | FilterbarExperimentVariation
    | OttoUpLogoExperimentVariation
    | PolarisSwitchButtonExperimentVariation
    | undefined;
  d666?: DummyExperimentVariation;
  e3792?: NextBestFacetExperimentVariation;
  e3911?: FilterbarExperimentVariation;
  e3921?: OttoUpLogoExperimentVariation;
  e3972?: PolarisSwitchButtonExperimentVariation;
};

let experiments: Experiments;

export function initExperiments() {
  const data = getElementById("leafcutter_experiments")?.dataset;
  if (data) {
    experiments = {};
    for (const key in data) {
      const variation = data[key];
      if (variation) {
        (experiments as Experiments)[key.toLowerCase()] = variation as Experiments[keyof Experiments];
      }
    }
  }
}

export function getActiveVariation<T extends keyof Experiments>(
  exp: T,
  defaultVariation?: Experiments[T],
): Experiments[T] | undefined {
  return experiments ? experiments[exp] || defaultVariation : defaultVariation;
}

export function isActiveVariation<T extends keyof Experiments>(exp: T, variation: Experiments[T]): boolean {
  return experiments ? experiments[exp] === variation : false;
}

/**
 *
 */
export function activeExperiments(): Readonly<Experiments> {
  return { ...experiments };
}
